import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';
import { modal } from '../../components/Base/Modal';

function* getCashbacks() {
  try {
    const { data, status } = yield call(api.cashback.getCashbacks);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_CASHBACKS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_CASHBACKS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createCashback({ payload }) {
  try {
    const { data, status } = yield call(api.cashback.createCashback, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.POST_CREATE_CASHBACK_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });

    modal.close();
    yield put({ type: types.GET_CASHBACKS_START });
  } catch (error) {
    yield put({ type: types.POST_CREATE_CASHBACK_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* editCashback({ payload }) {
  try {
    const { status } = yield call(api.cashback.editCashback, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_CASHBACK_SUCCESS });
    yield put({ type: types.GET_CASHBACKS_START });
    notification({ type: 'success', message: 'Success' });

    modal.close();
  } catch (error) {
    yield put({ type: types.PUT_CASHBACK_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deleteCashback({ payload }) {
  try {
    const { status } = yield call(api.cashback.deleteCashback, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.DELETE_CASHBACK_SUCCESS,
      payload: payload.params.cashback_id,
    });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.DELETE_CASHBACK_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* getUsersCashback({ payload }) {
  try {
    const { data, status } = yield call(api.cashback.getUsersCashback, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.GET_USERS_CASHBACKS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({ type: types.GET_USERS_CASHBACKS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* cashbacks() {
  yield all([
    takeLatest(types.GET_CASHBACKS_START, getCashbacks),
    takeLatest(types.POST_CREATE_CASHBACK_START, createCashback),
    takeLatest(types.PUT_CASHBACK_START, editCashback),
    takeLatest(types.DELETE_CASHBACK_START, deleteCashback),
    takeLatest(types.GET_USERS_CASHBACKS_START, getUsersCashback),
  ]);
}
